import i18n from '@/i18n';
import { getInfoUserLocalStorage } from '@/utils/handlers';
import { isRolePartner } from '@/views/pages/require/handlers.js';

const TABS = () => {
    return [
        {
            id: 1,
            name: i18n.t('landingPage.list.tabBasic'),
            disabled: false
        },
        {
            id: 2,
            name: i18n.t('landingPage.list.tabDesign'),
            disabled: false
        },
        {
            id: 3,
            name: i18n.t('landingPage.list.tabBlocks'),
            disabled: false
        },
        {
            id: 4,
            name: i18n.t('landingPage.list.tabFisrtView'),
            disabled: false
        },
        {
            id: 5,
            name: i18n.t('landingPage.list.tabTimeApp'),
            disabled: false
        },
        {
            id: 6,
            name: i18n.t('landingPage.list.tabPrizes'),
            disabled: false
        },
        {
            id: 7,
            name: i18n.t('landingPage.list.tabTargetProduct'),
            disabled: false
        },
        {
            id: 8,
            name: i18n.t('landingPage.list.tabMethodsApp'),
            disabled: false
        },
        {
            id: 9,
            name: i18n.t('landingPage.list.tabReceiptPhotography'),
            disabled: false
        },
        {
            id: 10,
            name: i18n.t('landingPage.list.tabRuleApp'),
            disabled: false
        },
        {
            id: 11,
            name: i18n.t('landingPage.list.tabContact'),
            disabled: false
        },
        {
            id: 12,
            name: i18n.t('landingPage.list.tabShareBlock'),
            disabled: false
        }
        // {
        //     id: 13,
        //     name: i18n.t('landingPage.list.tabButton'),
        //     disabled: false
        // },
        // {
        //     id: 14,
        //     name: i18n.t('landingPage.list.tabBlockAdd'),
        //     disabled: false
        // }
        // {
        //     id: 16,
        //     name: '応募ボタンブロックでの公開前・公開後切り替え - Chuyển đổi nút',
        //     disabled: false
        // },
        // {
        //     id: 17,
        //     name: 'LPの公開前後でのグレーアウト - Màu xám',
        //     disabled: false
        // },
        // {
        //     id: 18,
        //     name: '応募ボタンブロックでの公開前・公開後切り替え - Xác thực cơ bản',
        //     disabled: false
        // }
    ];
};

const TABS_UPLOAD = () => {
    return [
        {
            id: 1,
            name: i18n.t('landingPage.upload.tabBasic'),
            stage: 0,
            disabled: false
        },
        {
            id: 2,
            name: i18n.t('landingPage.upload.tabLPStart'),
            stage: 1,
            disabled: false
        },
        {
            id: 3,
            name: i18n.t('landingPage.upload.tabCampaignStart'),
            stage: 2,
            disabled: false
        },
        {
            id: 4,
            name: i18n.t('landingPage.upload.tabCampaignEnd'),
            stage: 3,
            disabled: false
        }
    ];
};

const LP_TYPE = {
    NORMAL: 1,
    UPLOAD: 2
};

const LP_TYPE_FILTER_OPTIONS = [
    { id: '', value: '全て' },
    { id: 1, value: '通常' },
    { id: 2, value: 'アップロード' }
];

const INIT_BLOCKS = () => {
    return [
        {
            name: 'ヘッダーブロック',
            is_visibled: true,
            block_default: true,
            key: 'header_information',
            key_parent: ''
        },
        {
            name: 'ファーストビュー',
            is_visibled: true,
            block_default: true,
            key: 'first_view',
            key_parent: ''
        },
        {
            name: '自由ブロック',
            is_visibled: false,
            block_default: true,
            key: 'free_blocks',
            key_parent: 'first_view'
        },
        {
            name: '応募ボタンブロック',
            is_visibled: false,
            block_default: true,
            key: 'button_blocks',
            key_parent: 'first_view'
        },
        {
            name: '応募期間',
            is_visibled: true,
            block_default: true,
            key: 'application_period',
            key_parent: ''
        },
        {
            name: '自由ブロック',
            is_visibled: false,
            block_default: true,
            key: 'free_blocks',
            key_parent: 'application_period'
        },
        {
            name: '応募ボタンブロック',
            is_visibled: false,
            block_default: true,
            key: 'button_blocks',
            key_parent: 'application_period'
        },
        {
            name: '賞品設定',
            is_visibled: true,
            block_default: true,
            key: 'block_prize',
            key_parent: ''
        },
        {
            name: '自由ブロック',
            is_visibled: false,
            block_default: true,
            key: 'free_blocks',
            key_parent: 'block_prize'
        },
        {
            name: '応募ボタンブロック',
            is_visibled: false,
            block_default: true,
            key: 'button_blocks',
            key_parent: 'block_prize'
        },
        {
            name: '対象商品',
            is_visibled: true,
            block_default: true,
            key: 'block_target_product',
            key_parent: ''
        },
        {
            name: '自由ブロック',
            is_visibled: false,
            block_default: true,
            key: 'free_blocks',
            key_parent: 'block_target_product'
        },
        {
            name: '応募ボタンブロック',
            is_visibled: false,
            block_default: true,
            key: 'button_blocks',
            key_parent: 'block_target_product'
        },
        {
            name: '応募方法設定',
            is_visibled: true,
            block_default: true,
            key: 'block_application_method',
            key_parent: ''
        },
        {
            name: '自由ブロック',
            is_visibled: false,
            block_default: true,
            key: 'free_blocks',
            key_parent: 'block_application_method'
        },
        {
            name: '応募ボタンブロック',
            is_visibled: false,
            block_default: true,
            key: 'button_blocks',
            key_parent: 'block_application_method'
        },
        {
            name: 'レシート撮影の注意事項',
            is_visibled: true,
            block_default: true,
            key: 'block_receipt_photography_tutorial',
            key_parent: ''
        },
        {
            name: '自由ブロック',
            is_visibled: false,
            block_default: true,
            key: 'free_blocks',
            key_parent: 'block_receipt_photography_tutorial'
        },
        {
            name: '応募ボタンブロック',
            is_visibled: false,
            block_default: true,
            key: 'button_blocks',
            key_parent: 'block_receipt_photography_tutorial'
        },
        {
            name: '応募規約',
            is_visibled: true,
            block_default: true,
            key: 'block_application_rule',
            key_parent: ''
        },
        {
            name: '自由ブロック',
            is_visibled: false,
            block_default: true,
            key: 'free_blocks',
            key_parent: 'block_application_rule'
        },
        {
            name: '応募ボタンブロック',
            is_visibled: false,
            block_default: true,
            key: 'button_blocks',
            key_parent: 'block_application_rule'
        },
        {
            name: 'お問い合わせ',
            is_visibled: true,
            block_default: true,
            key: 'block_contact',
            key_parent: ''
        },
        {
            name: '自由ブロック',
            is_visibled: false,
            block_default: true,
            key: 'free_blocks',
            key_parent: 'block_contact'
        },
        {
            name: '応募ボタンブロック',
            is_visibled: false,
            block_default: true,
            key: 'button_blocks',
            key_parent: 'block_contact'
        },
        {
            name: 'シェアブロック',
            is_visibled: true,
            block_default: true,
            key: 'block_share',
            key_parent: ''
        },
        {
            name: '自由ブロック',
            is_visibled: false,
            block_default: true,
            key: 'free_blocks',
            key_parent: 'block_share'
        },
        {
            name: '応募ボタンブロック',
            is_visibled: false,
            block_default: true,
            key: 'button_blocks',
            key_parent: 'block_share'
        }
    ];
};

const SOCIAL_MEDIA_SHARE = [
    {
        id: 1,
        name: 'Facebook',
        key: 'facebook',
        active: false,
        backgroundColor: '#1877f2',
        urlShare: 'https://www.facebook.com/sharer/sharer.php?u=',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Facebook_Logo_%282019%29.png/1200px-Facebook_Logo_%282019%29.png'
    },
    {
        id: 2,
        name: 'LINE',
        key: 'line',
        active: false,
        backgroundColor: '#14bd14',
        urlShare: 'https://social-plugins.line.me/lineit/share?url=',
        logo: 'https://static.vecteezy.com/system/resources/previews/023/986/611/non_2x/line-app-logo-line-app-logo-transparent-line-app-icon-transparent-free-free-png.png'
    },
    {
        id: 3,
        name: 'X',
        key: 'x',
        active: false,
        backgroundColor: '#000000',
        urlShare: 'https://twitter.com/intent/tweet?url=',
        logo: 'https://static.vecteezy.com/system/resources/previews/042/148/611/non_2x/new-twitter-x-logo-twitter-icon-x-social-media-icon-free-png.png'
    },
    {
        id: 4,
        name: 'Instagram',
        key: 'instagram',
        active: false,
        backgroundColor: '#ed5128',
        urlShare: 'https://www.instagram.com/?url=',
        logo: 'https://static.vecteezy.com/system/resources/previews/018/930/415/non_2x/instagram-logo-instagram-icon-transparent-free-png.png'
    },
    // {
    //     id: 5,
    //     name: 'Tiktok',
    //     key: 'tiktok',
    //     active: false,
    //     backgroundColor: '#000',
    //     urlShare: 'https://www.tiktok.com/share?url=',
    //     logo: 'https://static.vecteezy.com/system/resources/previews/016/716/450/non_2x/tiktok-icon-free-png.png'
    // },
    {
        id: 6,
        name: 'Pinterest',
        key: 'pinterest',
        active: false,
        backgroundColor: '#e6001d',
        urlShare: 'https://www.pinterest.com/pin/create/button/?url=',
        logo: 'https://static.vecteezy.com/system/resources/previews/018/930/744/non_2x/pinterest-logo-pinterest-transparent-free-png.png'
    }
];

const STATUS_SETTING_BASIC = [
    {
        id: 1,
        value: '非公開'
    },
    {
        id: 2,
        value: 'テスト公開（BASIC認証）'
    },
    {
        id: 3,
        value: '公開予約（404エラー）'
    },
    {
        id: 4,
        value: '公開中'
    },
    {
        id: 5,
        value: '終了'
    }
];

const STATUS_SETTING_PRIZE = [
    {
        id: '0',
        value: '有効'
    },
    {
        id: 1,
        value: '無効の切り替え'
    }
];

const STATUS_FORM = [
    {
        id: 1,
        value: '公開前'
    },
    {
        id: 2,
        value: '終了後'
    },
    {
        id: 3,
        value: '下書き'
    }
];

const configs = {
    campaign: {
        trackBy: 'id',
        label: 'name',
        error: false,
        isRemove: false
    },
    nameLandingPage: {
        trackBy: 'id',
        label: 'name',
        error: false,
        isRemove: false
    },
    client: {
        trackBy: 'id',
        label: 'name',
        error: false,
        isRemove: false
    },
    configTable: {
        headers: [
            {
                label: i18n.t('landingPage.list.lpID')
            },
            {
                label: i18n.t('landingPage.list.nameCampaign')
            },
            {
                label: i18n.t('landingPage.list.nameLandingPage')
            },
            {
                label: i18n.t('landingPage.list.urlPublic')
            },
            {
                label: i18n.t('landingPage.list.status')
            },
            {
                label: i18n.t('landingPage.list.startDateLP')
            },
            {
                label: i18n.t('landingPage.list.endDateLP')
            }
        ]
    },
    configPage: {
        total: 0,
        limit: 10,
        page: 1
    },
    configModalListPrv: {
        title: '',
        model: false,
        scrollable: true,
        hideFooter: false,
        centered: false,
        size: 'xl'
    }
};

const LIST_FONT_PAGE = [
    {
        id: 1,
        name: 'Yuji Mai',
        url: 'https://fonts.googleapis.com/css2?family=Yuji+Mai&display=swap',
        property_style: {
            fontFamily: "'Yuji Mai', serif",
            fontWeight: 400,
            fontStyle: 'normal'
        }
    },
    {
        id: 2,
        name: 'Noto Sans JP',
        url: 'https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100..900&family=Yuji+Mai&display=swap',
        property_style: {
            fontFamily: "'NotoSansJP', sans-serif",
            fontWeight: 400,
            fontStyle: 'normal'
        }
    },
    {
        id: 3,
        name: 'Hachi Maru Pop',
        url: 'https://fonts.googleapis.com/css2?family=Hachi+Maru+Pop&family=Noto+Sans+JP:wght@100..900&family=Yuji+Mai&display=swap',
        property_style: {
            fontFamily: "'Hachi Maru Pop', cursive",
            fontWeight: 400,
            fontStyle: 'normal'
        }
    },
    {
        id: 4,
        name: 'Noto Serif JP',
        url: '',
        property_style: {
            fontFamily: 'Noto Serif JP',
            fontWeight: 400,
            fontStyle: 'normal'
        }
    },
    {
        id: 5,
        name: 'M PLUS 1p',
        url: '',
        property_style: {
            fontFamily: 'MPLUS1p',
            fontWeight: 400,
            fontStyle: 'normal'
        }
    },
    {
        id: 6,
        name: 'Sawarabi Gothic',
        url: '',
        property_style: {
            fontFamily: 'SawarabiGothic',
            fontWeight: 400,
            fontStyle: 'normal'
        }
    },
    {
        id: 7,
        name: 'Zen Old Mincho',
        url: '',
        property_style: {
            fontFamily: 'ZenOldMincho',
            fontWeight: 400,
            fontStyle: 'normal'
        }
    }
];

const SQUARE_TYPE_PAGE = [
    {
        id: 1,
        value: 'スクエア'
    },
    {
        id: 2,
        value: 'サークル'
    }
];

const STT_HAS_BASIC_AUTH = [2];

const initFormSearch = () => {
    return {
        id: null,
        campaign_name: null,
        name: null,
        from_date: {
            campaign_start_date: '',
            campaign_end_date: '',
            lp_start_date: '',
            lp_end_date: ''
        },
        to_date: {
            campaign_start_date: '',
            campaign_end_date: '',
            lp_start_date: '',
            lp_end_date: ''
        },
        filters: {
            status: null,
            business_pic: null,
            instruction_pic: null,
            type: ''
        },
        has: {
            partner: isRolePartner() ? getInfoUserLocalStorage().partner_id ?? '' : ''
        }
    };
};

const STYLE_SHOW_TITLE = [5];

const initFormRegister = () => {
    return {
        //----- setting basic --------------
        lp_type: 1,
        resources_zip: [],
        resources_zip_start: [],
        resources_zip_going: [],
        resources_zip_end: [],
        campaign: getInfoUserLocalStorage()?.default_campaign ?? null,
        code: '',
        name: '',
        number_cp: '',
        custom_domain_id: null,
        custom_domain: null,
        sale_staff: '',
        person_in_charge: '',
        zac_id: '',
        sfid: '',
        campaign_entity_id: '',
        //  start date cp
        campaign_start_date: '',
        campaign_start_time: '',
        //  end date cp
        campaign_end_date: '',
        campaign_end_time: '',
        //  start date lp
        lp_start_date: '',
        lp_start_time: '',
        //  end date lp
        lp_end_date: '',
        lp_end_time: '',
        // publication_starts_date
        publication_start_date: '',
        publication_start_time: '',
        // publication_ends_date
        publication_end_date: '',
        publication_end_time: '',

        status: '1',
        automatic_status_update: true,
        keywords: [],
        description: '',
        analytics: '',
        head_source: '',
        body_directly_below: '',
        og_image: null,
        url_public: '',
        landing_page_user: {
            username: '',
            password: ''
        },
        last_publish_updated: '',
        published_domain: null,
        //----- end setting basic --------------

        //----- start setting design --------------
        style_setting: {
            font: '',
            template_default: null,
            border_radius_type: '',
            pc: {
                background_image: null,
                background_color: '',
                is_repeat: false
            },
            sp: {
                background_image: null,
                background_color: '',
                is_repeat: false
            }
        },
        //----- end setting design --------------

        //----- start setting blocks --------------
        blocks_settings: INIT_BLOCKS().map((item, idx) => {
            item.order_index = idx;
            return item;
        }),
        //----- end setting blocks --------------

        //----- start header_information --------------
        header_information: {
            html_content_first_view: '',
            html_content_finished_view: ''
        },
        //----- end header_information --------------

        //----- start setting firstview --------------
        first_view: {
            image: null,
            finished_image: null,
            html_content: ''
        },
        //----- end setting firstview --------------

        //----- start setting application period  --------------
        application_period: {
            title: '応募期間',
            style: null,
            start_date: '',
            end_date: '',
            html_content: ''
        },
        //----- end setting application period  --------------

        //----- start setting prize settings  --------------
        prize_settings: {
            title: '応募期間',
            title_image: null,
            size_title: '',
            color_title: '',
            background_title: '',
            background: {
                image: '',
                color: '#ffffff'
            },
            is_repeat: false,
            style: {
                id: 1,
                name: 'A'
            },
            html_content: '',
            prizes: []
        },
        //----- end setting prize settings  --------------

        //----- start setting target product settings  --------------
        block_target_product: {
            title_block: 'Trương trình quay số trúng thưởng !',
            title_image: null,
            size_title: '',
            color_title: '',
            background_title: '',
            background_image: null,
            background_color: '',
            is_repeat: false,
            style: null,
            target_products: [],
            html_content: ''
        },
        //----- end setting target product settings  --------------

        //----- start setting application method settings  --------------
        block_application_method: {
            title_block: 'Trương trình PHƯƠNG THỨC ỨNG TUYỂN !',
            title_image: null,
            size_title: '',
            color_title: '',
            background_title: '',
            background_image: null,
            background_color: '',
            is_repeat: false,
            style: null,
            application_methods: [],
            html_content: ''
        },
        //----- end setting application method settings  --------------

        //----- start setting receipt photography settings  --------------
        block_receipt_photography_tutorial: {
            html_content: ''
        },
        //----- end setting receipt photography settings  --------------

        //----- start setting application rule settings  --------------
        block_application_rule: {
            title_block: '応募規約',
            size_title: '',
            color_title: '',
            background_title: '',
            background_image: null,
            background_color: '#ffffff',
            is_repeat: false,
            html_content: ''
        },
        //----- end setting application rule settings  --------------

        //----- start setting share settings  --------------
        block_share: {
            title_block: 'シェアブロック',
            background_image: null,
            background_color: '#ffffff',
            is_repeat: false,
            url: '',
            share_text: '',
            html_content: '',
            hashtag: [],
            platform: {
                facebook: {
                    active: false,
                    url: ''
                },
                line: {
                    active: false,
                    url: ''
                },
                x: {
                    active: false,
                    url: ''
                },
                instagram: {
                    active: false,
                    url: ''
                },
                pinterest: {
                    active: false,
                    url: ''
                }
            }
        },
        //----- end setting share settings  --------------

        //----- start setting contact settings  --------------
        block_contact: {
            title_block: 'お問い合わせ',
            size_title: '',
            color_title: '',
            background_title: '',
            background_image: null,
            background_color: '#ffffff',
            is_repeat: false,
            style: null,
            contact_secretariat_name: '',
            tel: '',
            mail: '',
            html_content: ''
        },
        //----- end setting contact settings  --------------

        //----- start setting free blocks settings  --------------
        free_blocks: [],
        //----- start setting free blocks settings  --------------

        //----- start setting button blocks settings  --------------
        button_blocks: []
        //----- start setting button blocks settings  --------------
    };
};

export {
    TABS,
    TABS_UPLOAD,
    LP_TYPE,
    LP_TYPE_FILTER_OPTIONS,
    STATUS_FORM,
    configs,
    LIST_FONT_PAGE,
    SQUARE_TYPE_PAGE,
    STATUS_SETTING_BASIC,
    STATUS_SETTING_PRIZE,
    SOCIAL_MEDIA_SHARE,
    STYLE_SHOW_TITLE,
    STT_HAS_BASIC_AUTH,
    initFormSearch,
    initFormRegister
};
